module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/svg--check-white-9ec34148.svg";